var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-6 -6 32 32",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill:#bcbcbc;}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10,13c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1-0.1-0.2-0.1l-5-4.9C4.5,7.8,4.5,7.7,4.5,7.5c0-0.1,0.1-0.3,0.2-0.4 C4.7,7.1,4.9,7,5,7c0.1,0,0.3,0.1,0.4,0.2l4.6,4.5l4.6-4.5C14.7,7.1,14.9,7,15,7c0.1,0,0.3,0.1,0.4,0.2c0.1,0.1,0.2,0.2,0.2,0.4 c0,0.1-0.1,0.3-0.2,0.4l-5,4.9c-0.1,0.1-0.1,0.1-0.2,0.1C10.1,13,10.1,13,10,13z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevron);
export default __webpack_public_path__ + "static/media/chevron.7267c518eb9d16d7879b0c19eb96dc0d.svg";
export { ForwardRef as ReactComponent };